/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Templates_Pick_TypInputs */

const cs_social_templates_pick_typ = /** @type {(inputs: Social_Templates_Pick_TypInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybrat .typ soubor`)
};

const en_social_templates_pick_typ = /** @type {(inputs: Social_Templates_Pick_TypInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose .typ file`)
};

/**
* | output |
* | --- |
* | "Choose .typ file" |
*
* @param {Social_Templates_Pick_TypInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_templates_pick_typ = /** @type {((inputs?: Social_Templates_Pick_TypInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Templates_Pick_TypInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_templates_pick_typ(inputs)
	return cs_social_templates_pick_typ(inputs)
});